import type { LocaleMessageBundle } from '../../types'
import { productBrandMessages } from './brand'
import { productGroupMessages } from './group-product'
import { productLocationMessages } from './location'
import { productMessages as productFeatureMessages } from './product'
import { productUnitMessages } from './unit'

export const productMessages: LocaleMessageBundle = {
  vi: {
    ...productFeatureMessages.vi,
    ...productGroupMessages.vi,
    ...productBrandMessages.vi,
    ...productUnitMessages.vi,
    ...productLocationMessages.vi,
  },
  en: {
    ...productFeatureMessages.en,
    ...productGroupMessages.en,
    ...productBrandMessages.en,
    ...productUnitMessages.en,
    ...productLocationMessages.en,
  },
}
